export enum MemberEmployerStatusType {
  primary = 1,
  secondary = 2,
  previous = 3,
}
